import { render, staticRenderFns } from "./AppLogin.vue?vue&type=template&id=70d5c27a&"
import script from "./AppLogin.vue?vue&type=script&lang=js&"
export * from "./AppLogin.vue?vue&type=script&lang=js&"
import style0 from "./AppLogin.vue?vue&type=style&index=0&id=70d5c27a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports